import { Command, HttpMethod } from "~/extensions/api";
export class GetMessageCommand extends Command {
    constructor() {
        super(HttpMethod.Get, "common/messages");
    }
}
